import BukkuTooltip from "../Tooltip";
import React from "react";

export function TooltipWrapper({children, hideTooltip, title, ...props}) {
    if (!hideTooltip) {
        return (
            <BukkuTooltip
                title={title}
                hideTooltip={hideTooltip}
                {...props}
            >
                {children}
            </BukkuTooltip>
        );
    }
    return children;
}
